import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	loading: true,
	error: false,
	data: [],
	columns: [],
	deleteItem: {
		success: false,
		error: false
	},
	options: {
		pages: 0,
		page: 0,
		total_results: 0,
		startIndex: 0,
		filters: {
			query: ''
		}
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH EVENT_LIVE PRICES ***************
			case types.FETCH_EVENT_LIVE_PRICES_LOADING:
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_EVENT_LIVE_PRICES_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				draft.columns = action.payload.input.columns;
				draft.options.pages = action.payload.pages;
				draft.options.total_results = action.payload.recordsFiltered;
				draft.options.startIndex = action.payload.startIndex;
				draft.options.page = action.payload.page;
				return;

			case types.FETCH_EVENT_LIVE_PRICES_ERROR:
				draft.error = action.payload;
				return;

			// *************** DELETE PRICE ***************
			case types.DELETE_EVENT_LIVE_PRICE_LOADING:
				draft.deleteItem.success = false;
				draft.deleteItem.error = false;
				return;

			case types.DELETE_EVENT_LIVE_PRICE_SUCCESS:
				draft.deleteItem.success = action.payload;
				draft.deleteItem.error = false;
				return;

			case types.DELETE_EVENT_LIVE_PRICE_ERROR:
				draft.deleteItem.error = action.payload;
				return;

			default:
				return state;
		}
	});
